<script>
import sumBy from 'lodash/sumBy';
import get from 'lodash/get';

export default {
  props: {
    customer: Object,
    userLoggedIn: Boolean,
  },
  computed: {
    dashboardLabel() {
      return this.customer.role === 'CUSTOMER' ? 'Profile' : 'Dashboard';
    },
  },
};
</script>

<template lang='pug'>
.flex.overflow-hidden.justify-center.bg-brand-secondary.h-2_75.header-top
  .flex.justify-between.h-full.container.px-1

    .flex.items-center
      //- template
        strong.bg-brand.rounded-full.w-5.h-5.text-white.mr-_5.text-center.leading-5 15% off
        .text-yellow everything. Ends Monday, May 13.

    .flex.text-white.items-center.text-sm
      .text-md.mr-2.cursor-pointer(
        tabindex='0',
        @click='$emit("navigate", "help")',
        @keyup.enter='$emit("navigate", "help")',
      ) Help
      router-link.text-md.mr-2.cursor-pointer(
        tabindex='0',
        tag='div',
        :to='{ name: "trackOrder" }',
      ) Track Order
      template(v-if='userLoggedIn')
        .text-md.mr-2.cursor-pointer(
          tabindex='0',
          @click='$emit("navigate", "dashboard")',
          @keyup.enter='$emit("navigate", "dashboard")',
        ) {{dashboardLabel}}
        .text-md.cursor-pointer(
          tabindex='0',
          @click='$emit("log-out")',
          @keyup.enter='$emit("log-out")',
        ) Sign Out
      router-link.text-md.cursor-pointer(
        v-else,
        tabindex='0',
        tag='div',
        :to='{ name: "signIn" }',
      ) Sign In
</template>

<style>
@import '~import/index';
</style>